import { c as _c } from "react/compiler-runtime";
import { Text, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';
export const CalcField = t0 => {
  const $ = _c(8);
  const {
    label,
    hint,
    children
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <Text fontSize="md" fontWeight="semibold">{label}</Text>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hint) {
    t2 = hint && <Text color="colorPalette.fg/50" fontSize="sm" marginBottom={2}>{hint}</Text>;
    $[2] = hint;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <VStack align="stretch" gap={1}>{t1}{t2}{children}</VStack>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};